module.exports = __webpack_public_path__ + "static/undraw_building_re_xfcm-3d0bfa29fac000c3165b2137c223b9db.svg";